import {axiosInstance} from '../helper/appclient'
import get from 'lodash/get'
import {
    CHANGE_PASSWORD_URL,
    CONFIRM_RESET_PASSWORD_URL,
    FIRST_TIME_CHANGE_PASSWORD_URL,
    LOGIN_URL
} from '../config/url-config'

import {
    ERR_MSG, SESS_EXPIRED_TEXT, SUCCESS_CODES,
    CFM_RST_PASSWD_ERR_101,
    CFM_RST_PASSWD_ERR_102,
    CFM_RST_PASSWD_ERR_103,
    CFM_RST_PASSWD_ERR_104, CURR_PASS_ERR, MFA_OTP_WRONG_ERR, CFM_RST_PASSWD_ERR_105, CFM_RST_PASSWD_ERR_106
} from "../constants/constants";
import {store} from "../store/store";
import {loadSessionExpired} from "../store/action";
import {extractStatusCode} from "../helper/responsehelper";


export const cfmResetPasswordStatus = {
    [CFM_RST_PASSWD_ERR_101]:ERR_MSG,
    [CFM_RST_PASSWD_ERR_102]:ERR_MSG,
    [CFM_RST_PASSWD_ERR_103]: MFA_OTP_WRONG_ERR,
    [CFM_RST_PASSWD_ERR_104]: ERR_MSG,
    [CFM_RST_PASSWD_ERR_105]:ERR_MSG,
    [CFM_RST_PASSWD_ERR_106]:ERR_MSG,
    "UNK-ERR-102": ERR_MSG,
};
const constructConfirmResetPassword = (formFields)=>(
    {
        userName:get(formFields,"userName"),
        otpCode:get(formFields,"otpCode"),
        newPassword:get(formFields,"newPassword"),
    }
)
export const confirmResetPasswordService = (formFields)=>{
    console.log("formFields123",formFields)
    const confirmResetPaswordRequest = constructConfirmResetPassword(formFields)
    console.log("formFields234",formFields)
    return new Promise((resolve,reject)=>{
        axiosInstance
            .post(CONFIRM_RESET_PASSWORD_URL(),confirmResetPaswordRequest)
            .then((response) => {
                let statusCode = extractStatusCode(response)
                console.log("change statusCode",statusCode)
                if(SUCCESS_CODES.CFM_RESET_PASSWORD.includes(statusCode)){
                    resolve(response)
                }else{
                    let errText = cfmResetPasswordStatus[statusCode]
                    if(errText === SESS_EXPIRED_TEXT){
                        store.dispatch(loadSessionExpired(true))
                    }
                    reject(errText || ERR_MSG )
                }
            })
            .catch((error) => {
                console.log(error)
                reject(ERR_MSG)
            });
    })
}